import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { useMemo } from "react";
export var useSearchPlaceholder = function (subCategoryId) {
    return useMemo(function () {
        switch (subCategoryId) {
            case ESubProductIds.StructuredProducts:
                return "Search by name, category and more";
            case ESubProductIds.NCD:
                return "Search by name, category and more";
            case ESubProductIds.Bonds:
                return "Search by name, category and more";
            case ESubProductIds.UnlistedShares:
                return "Search by company name and more";
            default:
                return "";
        }
    }, [subCategoryId]);
};
